import type { TaxIdentityResource } from '@repo/api-client';

/**
 * Which GST registration an outlet trades under (#321) — the one its tills
 * print at the top of a tax invoice. Shared by the list and both dialogs.
 */

/** A registration's name, as the outlets list shows it. */
export const labelForTaxIdentity = (identity: TaxIdentityResource): string =>
  identity.registeredName ?? identity.gstin ?? 'Registration not yet named';

/** In the picker the GSTIN rides along, because the GSTIN is what prints. */
export const optionLabelForTaxIdentity = (identity: TaxIdentityResource): string =>
  identity.gstin === null || identity.registeredName === null
    ? labelForTaxIdentity(identity)
    : `${identity.registeredName} · ${identity.gstin}`;

export const TAX_IDENTITY_REQUIRED = 'Choose the GST registration this outlet trades under.';
